import { render, staticRenderFns } from "./electronicInvoiceInput.vue?vue&type=template&id=f220f340&scoped=true&"
import script from "./electronicInvoiceInput.vue?vue&type=script&lang=ts&"
export * from "./electronicInvoiceInput.vue?vue&type=script&lang=ts&"
import style0 from "./electronicInvoiceInput.vue?vue&type=style&index=0&id=f220f340&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f220f340",
  null
  
)

export default component.exports